export { default } from "./src/page";
